const prescriptionData = {
  CorPrimaria: '#ff3f72',
  CorSecundaria: '',
  LogoURL:
    'https://starbem-public-prd.s3.amazonaws.com/brand/6dee7dcf-af5e-4526-bb3c-86b3ce85b783.png',
  Medico: {
    Especialidades: ['Clínica Geral'],
    RegistroProfissional: {
      Numero: '',
      Conselho: 'CRM',
      UF: '',
    },
    Nome: '',
    Documento: '',
    Endereco: {
      Endereco1: 'Rua Santa Catarina, 1940, Sala 06',
      Endereco2: '',
      Cidade: 'Franca',
      Bairro: 'Jardim Bethania',
      Estado: 'SP',
      CodigoPostal: '14401351',
    },
    Sexo: '',
    Email: '',
  },
  Paciente: {
    Nome: '',
    Nascimento: '',
    Sexo: '',
    TelefoneCelular: '',
    Email: '',
    Altura: '',
    Peso: '',
    Endereco: {
      Endereco1: '',
      Endereco2: '',
      Cidade: '',
      Bairro: '',
      Estado: '',
      CodigoPostal: '',
    },
    Documento: '',
    Alergias: [],
    ReferenciaExterna: '',
    Responsaveis: [],
  },
  RegistroProntuarioEletronico: {
    ReferenciaExterna: '',
    TipoConsulta: 'Teleconsulta',
  },
  Estabelecimento: {
    Nome: 'StarBem Desenvolvimento de Software LTDA',
    CNES: '',
    Logo: 'https://starbem-public-stg.s3.us-east-2.amazonaws.com/brand/489d70a1-288f-4699-a976-df0696cfefb6.jpg',

    Endereco: {
      Endereco1: 'CNPJ 39.382.615/0001-65,',
      Endereco2: 'Rua Santa Catarina, 1940, Sala 06',
      Bairro: 'Jardim Bethania',
      Cidade: 'Franca',
      Estado: 'SP',
      CodigoPostal: '14401351',
    },
    Contato: {
      TelefoneComercial: '11991987278',
      Celular: '11991987278',
      Site: 'www.starbem.app',
    },
  },
  CertificadoDigitalObrigatorio:
    process.env.REACT_APP_NEXODATA_REQUIRED_CERTIFIED !== 'false',
}

export default prescriptionData
